import React, { useEffect, useState } from "react";

const TaxAdvisory = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (isMobile) {
    return (
      <div>
        <div></div>TaxAdvisory
      </div>
    );
  }
  return (
    <div>
      <div>TaxAdvisoryp</div>
    </div>
  );
};

export default TaxAdvisory;
